import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { authErrorMessage, useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Signup() {
  const { user, signup, loginWithGoogle } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const redirect = params.get("redirect") || "/dashboard";

  useEffect(() => {
    if (user) navigate(redirect, { replace: true });
  }, [user, navigate, redirect]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signup(email, password, name);
      toast.success("Account created — welcome to Note Console");
      navigate(redirect);
    } catch (err) {
      toast.error(err?.message?.replace("Firebase: ", "") || "Signup failed");
    } finally {
      setLoading(false);
    }
  };

  const google = async () => {
    try {
      const signedInUser = await loginWithGoogle();
      if (signedInUser) {
        toast.success("Signed in with Google");
        navigate(redirect);
      }
    } catch (error) {
      console.error(error);
      toast.error(authErrorMessage(error));
    }
  };

  return (
    <div data-testid="signup-page" className="container-nc py-20 min-h-[70vh] grid place-items-center">
      <div className="w-full max-w-md">
        <p className="overline mb-4 text-center">Create an account</p>
        <h1 className="font-serif text-4xl md:text-5xl text-espresso text-center leading-tight">
          Start your <span className="italic">Life OS.</span>
        </h1>
        {redirect === "/checkout" && (
          <p className="text-xs text-muted_brown text-center mt-4">
            We'll bring you back to checkout after signup.
          </p>
        )}

        <form onSubmit={onSubmit} className="mt-10 space-y-4">
          <input required placeholder="Full name" data-testid="signup-name" className="input-nc" value={name} onChange={(e) => setName(e.target.value)} />
          <input required type="email" placeholder="Email" data-testid="signup-email" className="input-nc" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input required type="password" placeholder="Password (min 6 characters)" data-testid="signup-password" className="input-nc" value={password} onChange={(e) => setPassword(e.target.value)} />
          <button data-testid="signup-submit" disabled={loading} className="btn-primary w-full disabled:opacity-60">
            {loading ? "Creating account..." : "Create Account"}
          </button>
        </form>

        <div className="my-6 flex items-center gap-3 text-xs text-muted_brown">
          <div className="flex-1 h-px bg-line"/> or <div className="flex-1 h-px bg-line"/>
        </div>

        <button onClick={google} data-testid="signup-google" className="btn-outline w-full">
          Continue with Google
        </button>

        <p className="text-sm text-muted_brown text-center mt-8">
          Already have an account? <Link to={`/login${redirect !== "/dashboard" ? `?redirect=${redirect}` : ""}`} className="text-espresso underline">Log in</Link>
        </p>
      </div>
    </div>
  );
}
